import { useTranslation } from 'react-i18next';
import Button from '@/components/ui/Button';

interface ProjectIntroScreenProps {
  onStart: () => void;
}

/** The wizard's opening screen: what a project is for, and the three steps ahead. */
const ProjectIntroScreen = ({ onStart }: ProjectIntroScreenProps) => {
  const { t } = useTranslation();

  const steps = [
    t('projects.wizard.intro.step1'),
    t('projects.wizard.intro.step2'),
    t('projects.wizard.intro.step3'),
  ];

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 flex flex-col gap-6 px-8 max-md:px-4 py-2 overflow-y-auto">
        <h3 className="heading-h3-semibold text-(--font-primary)">
          {t('projects.wizard.intro.title')}
        </h3>

        <section className="flex flex-col gap-2">
          <h4 className="body-lr-semibold text-(--font-primary)">
            {t('projects.wizard.intro.whenUsefulTitle')}
          </h4>
          <p className="body-md-regular text-(--font-secondary)">
            {t('projects.wizard.intro.whenUsefulBody')}
          </p>
        </section>

        <section className="flex flex-col gap-3">
          <h4 className="body-lr-semibold text-(--font-primary)">
            {t('projects.wizard.intro.stepsTitle')}
          </h4>
          <ol className="flex flex-col gap-3">
            {steps.map((step, index) => (
              <li key={step} className="flex items-center gap-3">
                <span className="w-7 h-7 shrink-0 rounded-full bg-(--surface-primary) text-white flex items-center justify-center body-sm-semibold">
                  {index + 1}
                </span>
                <span className="body-md-regular">{step}</span>
              </li>
            ))}
          </ol>
        </section>
      </div>

      <footer className="shrink-0 flex justify-end px-8 py-4 max-md:px-4">
        <Button variant="primary" onClick={onStart}>
          {t('projects.wizard.intro.start')}
        </Button>
      </footer>
    </div>
  );
};

export default ProjectIntroScreen;
